import { api } from '../App';

/**
 * Track user activity
 * @param {string} activityType - Type: "login", "ai_query", "library_view", "wizard_use", "zap_tool", "page_view"
 * @param {string} activityDetail - Additional context (optional)
 * @param {string} feature - Feature name (optional)
 */
export const trackActivity = async (activityType, activityDetail = null, feature = null) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return; // Don't track if not logged in
    
    await api.post('/activity/track', {
      activity_type: activityType,
      activity_detail: activityDetail,
      feature: feature
    });
  } catch (error) {
    // Silently fail - don't disrupt user experience for tracking
    console.debug('Activity tracking failed:', error);
  }
};

export default trackActivity;
